/**
 * Core utilities shared between DialogFlow and StepFlow
 */
import type { FlowStepComponent } from './types';

/**
 * Validate flow step configuration
 * Ensures each step has a unique status value
 */
export function validateFlowStepConfig(steps: FlowStepComponent[]) {
  const statusList = steps.map((item) => item.status);
  const uniqueStatusList = Array.from(new Set(statusList));

  if (statusList.length !== uniqueStatusList.length) {
    throw new Error('Each step must have a unique `status` value.');
  }
}

/**
 * Compute keepAlive configuration for steps
 * Returns array of status values that should be cached
 */
export function computeKeepAliveInclude(
  steps: FlowStepComponent[],
  globalKeepAlive: boolean,
): string[] {
  const include: string[] = [];

  steps.forEach((item) => {
    if (!item.status) return;

    // When global keepAlive is enabled, cache all steps by default (unless explicitly set to false)
    // When global keepAlive is disabled, only cache steps explicitly set to true
    const shouldKeepAlive = globalKeepAlive
      ? item.keepAlive !== false
      : item.keepAlive === true;

    if (shouldKeepAlive) {
      include.push(item.status);
    }
  });

  return include;
}
